import React from 'react'

import { useTaskPageState } from '../../providers/TaskPageStateProvider'

const useTaskColumnSettings = key => {
  const { update, getColumnSettings } = useTaskPageState()

  const { order, visible } = React.useMemo(() => {
    return getColumnSettings(key)
  }, [getColumnSettings, key])

  return {
    columnOrder: order,
    columnVisible: visible,
    updateColumn: update(key)
  }
}

export default useTaskColumnSettings
